import { Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react'
import React from 'react'
import VariableApi from './TestMessage/VariableApi.js'
import ParserApi from './TestMessage/ParserApi.js'
import Header from '../components/Header.js'

const SendMessage = () => {
	return (
		<div>
			<Header />
			<div style={{ width: "50%", marginTop: "1rem", marginLeft: "2rem" }}>
				<Tabs >
					<TabList style={{ marginLeft: "1.5rem" }}>
						<Tab>Variable API</Tab>
						<Tab>Message API</Tab>
					</TabList>

					<TabPanels>
						<TabPanel>
							<VariableApi />
						</TabPanel>
						<TabPanel>
							<ParserApi />
						</TabPanel>

					</TabPanels>
				</Tabs>
			</div>
		</div>
	)
}

export default SendMessage